import { payoutsContract } from "@clipboard-health/contract-worker-app-bff";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import type z from "zod";

const GetLastPayoutResponseSchema = payoutsContract.getLastPayout.responses[200];

type GetLastPayoutResponse = z.infer<typeof GetLastPayoutResponseSchema>;

export const GET_LAST_PAYOUT_QUERY_KEY = ["get-last-payout"];

export function useGetLastPayout(
  /* eslint-disable @typescript-eslint/ban-types */
  options: UseQueryOptions<GetLastPayoutResponse | null> = {}
): UseQueryResult<GetLastPayoutResponse | null> {
  /* eslint-enable @typescript-eslint/ban-types */
  return useQuery({
    queryKey: GET_LAST_PAYOUT_QUERY_KEY,
    queryFn: async () => {
      try {
        const result = await get({
          url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/worker-payouts/last`,
          responseSchema: GetLastPayoutResponseSchema,
        });
        return result.data;
      } catch (error) {
        if (isAxiosError(error) && error.status === 404) {
          // fail silently on 404
          return null;
        }

        throw error;
      }
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_LAST_PAYOUT_FAILURE,
    },
    staleTime: 5 * 60_000,
    cacheTime: 5 * 60_000,
    ...options,
  });
}
